import { Select, Space } from "antd";
import { isEmpty } from "lodash";
import Flex from "modules/common/Flex";
import CardDiv from "modules/common/card-div/CardDiv";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CampaignMediumTable from "modules/utm_campaign/CampaignMediumTable";
import CampaignTable from "modules/utm_campaign/CampaignTable";
import { handleSortUtm } from "modules/utm_campaign/commonFunction";
import useUtmStore from "modules/utm_campaign/store";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";

function UtmCampaign() {
  const { utmData, utmLoading, fetchUtmData } = useUtmStore();
  const [page, newPage] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [sortedData, setSortedData] = useState([]);
  const [checkboxes, setCheckboxes] = useState("utm_campaign");

  const currentDate = new Date();
  const [compStartDate, setCompStartDate] = useState(
    currentDate.getTime() - 24 * 60 * 60 * 1000
  );
  const [endLastDate, setEndDate] = useState(currentDate);
  const [mergedData, setMergedData] = useState({});
  const [originalData, setOriginalData] = useState([]);
  const [submitFlag, setSubmitFlag] = useState(0);
  const [utmCopyData, setUtmCopyData] = useState(utmData);
  const [opa, setOpa] = useState("");
  const [opa1, setOpa1] = useState("");
  const [count, setCount] = useState(0);
  const [count1, setCount1] = useState(0);
  const [option, setOption] = useState(null);

  useEffect(() => {
    setUtmCopyData(utmData);
  }, [utmData]);

  useEffect(() => {
    const startDate = moment(endLastDate).startOf("day").toISOString();
    const endDate = moment(endLastDate).endOf("day").toISOString();
    const compareStartDate = moment(compStartDate)
      .startOf("days")
      .toISOString();
    const compareEndDate = moment(compStartDate).endOf("day").toISOString();
    fetchUtmData({
      startDate: startDate,
      endDate: endDate,
      compareStartDate: compareStartDate,
      compareEndDate: compareEndDate,
    });
  }, [submitFlag]);

  useEffect(() => {
    const mergedData = {};
    utmCopyData?.today?.forEach((todayItem) => {
      const matchingYesterdayItem = utmCopyData?.yesterday?.find(
        (yesterdayItem) =>
          yesterdayItem?.utm_campaign === todayItem?.utm_campaign
      );

      if (matchingYesterdayItem) {
        mergedData[todayItem?.utm_campaign] = {
          today: todayItem,
          yesterday: matchingYesterdayItem,
        };
      }
    });
    setMergedData(mergedData);
    const mappedKey = Object.keys(mergedData);
    setOriginalData(mappedKey);
    setSortedData(mappedKey);
  }, [utmCopyData, checkboxes]);

  const utmCampaignOptions = [
    ...originalData?.map((item) => {
      return { label: item, value: item };
    }),
  ];

  const utmMediumOptions = useMemo(() => {
    const uniqueMediums = new Set();
    const filteredOptions = utmData?.today?.reduce((options, item) => {
      if (!uniqueMediums.has(item.utm_medium)) {
        uniqueMediums.add(item.utm_medium);
        options.push({ label: item.utm_medium, value: item.utm_medium });
      }
      return options;
    }, []);
    return filteredOptions;
  }, [utmData]);

  const utmSourceOptions = useMemo(() => {
    const uniqueMediums = new Set();
    const filteredOptions = utmData?.today?.reduce((options, item) => {
      if (!uniqueMediums.has(item.utm_source)) {
        uniqueMediums.add(item.utm_source);
        if (!isEmpty(item?.utm_source)) {
          options.push({ label: item.utm_source, value: item.utm_source });
        }
      }
      return options;
    }, []);
    return filteredOptions;
  }, [utmData]);


  const mediumTodayGroupedData = useMemo(() => {
    const groupedData = {};
    utmData?.today?.forEach((entry) => {
      const medium = entry.utm_medium;
      if (!groupedData[medium]) {
        groupedData[medium] = [];
      }
      groupedData[medium].push(entry);
    });
    return groupedData;
  }, [utmData]);

  const mediumYesterdayGroupedData = useMemo(() => {
    const groupedData = {};
    utmData?.yesterday?.forEach((entry) => {
      const medium = entry.utm_medium;
      if (!groupedData[medium]) {
        groupedData[medium] = [];
      }
      groupedData[medium].push(entry);
    });
    return groupedData;
  }, [utmData]);

  const sourceTodayGroupedData = useMemo(() => {
    const groupedData = {};
    utmData?.today?.forEach((entry) => {
      const medium = entry.utm_source;
      if (!groupedData[medium]) {
        groupedData[medium] = [];
      }
      groupedData[medium].push(entry);
    });
    return groupedData;
  }, [utmData]);

  const sourceYesterdayGroupedData = useMemo(() => {
    const groupedData = {};
    utmData?.yesterday?.forEach((entry) => {
      const medium = entry.utm_source;
      if (!groupedData[medium]) {
        groupedData[medium] = [];
      }
      groupedData[medium].push(entry);
    });
    return groupedData;
  }, [utmData]);

  useEffect(() => {
    if (!sortedData?.length) {
      return;
    }
    async function calculate() {
      const numOfSubarrays = Math.max(
        Math.ceil((sortedData?.length || 0) / 10),
        0
      );

      const paginationArray = sortedData
        ? Array.from({ length: numOfSubarrays }, (_, index) => {
            const start = index * 10;
            const end = start + 10;
            return sortedData?.slice(start, end);
          })
        : [];
      setPageCount(Math.min(Math.ceil((sortedData?.length || 0) / 10), 100));
      setFilter(paginationArray[page - 1]);
    }
    calculate();
  }, [sortedData, page]);

  const handleSelectUtm = (option) => {
    if (checkboxes === "utm_campaign") {
      if (option) {
        setSortedData([
          ...originalData?.filter((item) => {
            return item === option;
          }),
        ]);
      } else {
        setSortedData(originalData);
      }
    }
    if (checkboxes === "utm_medium") {
      setOption(option);
    }
    if (checkboxes === "utm_source") {
      setOption(option);
    }

    newPage(1);
  };

  const handleClear = () => {
    const currentDate = new Date();
    setCompStartDate(currentDate.getTime() - 24 * 60 * 60 * 1000);
    setEndDate(currentDate);
    setSubmitFlag(submitFlag + 1);
  };

  const handleSubmit = () => {
    setSubmitFlag(submitFlag + 1);
  };

  const handleCheckboxToggle = (checkboxId) => {
    setCheckboxes(checkboxId);
    setUtmCopyData(utmData);
  };

  const utmOptions =
    checkboxes === "utm_campaign"
      ? utmCampaignOptions
      : checkboxes === "utm_medium"
      ? utmMediumOptions
      : utmSourceOptions;

  const handleSortGross = () => {
    handleSortUtm("sum", count1, setCount1, setUtmCopyData, setOpa1, utmData);
  };

  const handleSortCount = () => {
    handleSortUtm("count", count, setCount, setUtmCopyData, setOpa, utmData);
  };

  return (
    <dv>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2 fw-bold">UTM Campaign</div>
            <div className="d-flex gap-2">
              <Select
                allowClear
                onChange={handleSelectUtm}
                optionFilterProp="label"
                placeholder="Search a campaign"
                showSearch
                style={{ width: "20rem" }}
                className=" "
              >
                {!isEmpty(utmOptions) &&
                  utmOptions?.map((rep) => (
                    <Option label={rep.label} value={rep.value} key={rep}>
                      <Space align="center">
                        <div>{rep.label}</div>
                      </Space>
                    </Option>
                  ))}
              </Select>
              <div className="d-flex gap-2">
                <DatePicker
                  selected={compStartDate}
                  onChange={(date) => setCompStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Select previous Date"
                  maxDate={endLastDate}
                />
                <DatePicker
                  selected={endLastDate}
                  onChange={(date) => setEndDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Select current Date"
                  maxDate={new Date()}
                  minDate={compStartDate}
                />
                <button
                  className="btn btn-primary"
                  style={{ height: "2.25rem" }}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  className="btn btn-primary"
                  style={{ height: "2.26rem" }}
                  onClick={handleClear}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>
        }
        component={
          <>
            <Flex className="flex-wrap gap-2 gap-md-3 py-2">
              <Form.Check
                inline
                type="radio"
                id="item1Radio"
                label="utm_campaign"
                name="utm_campaign"
                checked={checkboxes === "utm_campaign"}
                onClick={() => handleCheckboxToggle("utm_campaign")}
              />
              <Form.Check
                inline
                type="radio"
                id="item2Radio"
                label="utm_medium"
                checked={checkboxes === "utm_medium"}
                onClick={() => handleCheckboxToggle("utm_medium")}
                name="inline-radio"
              />
              <Form.Check
                inline
                type="radio"
                id="item3Radio"
                label="utm_source"
                name="inline-radio"
                checked={checkboxes === "utm_source"}
                onClick={() => handleCheckboxToggle("utm_source")}
              />
            </Flex>
            {checkboxes === "utm_campaign" ? (
              <div>
                <CampaignTable
                  mappedKey={filterData}
                  utmLoading={utmLoading}
                  mergedData={mergedData}
                  opa={opa}
                  opa1={opa1}
                  handleSortGross={handleSortGross}
                  handleSortCount={handleSortCount}
                />
                <PaginationDiv
                  newPage={newPage}
                  paginationData={{
                    pageCount: pageCount || 1,
                    page: page,
                  }}
                />
              </div>
            ) : (
              <CampaignMediumTable
                mediumTodayGroupedData={mediumTodayGroupedData}
                mediumYesterdayGroupedData={mediumYesterdayGroupedData}
                sourceTodayGroupedData={sourceTodayGroupedData}
                sourceYesterdayGroupedData={sourceYesterdayGroupedData}
                checkboxes={checkboxes}
                option={option}
              />
            )}
          </>
        }
      />
    </dv>
  );
}

export default UtmCampaign;
